module.exports = __webpack_public_path__ + "static/media/discord-logo.145dc557.svg";